/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img[appImgFallback]',
})
export class ImgFallbackDirective {
  @Input() appImgFallback: string;

  constructor(private el: ElementRef) {}

  @HostListener('error') loadFallbackOnError() {
    const element: HTMLImageElement = this.el.nativeElement as HTMLImageElement;
    element.src = this.appImgFallback;
  }
}
